var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notes"},[_c('va-card',{attrs:{"title":_vm.$t('order.notes.notes')}},[_c('chat',{on:{"insertNote":_vm.insertNote},model:{value:(_vm.notes),callback:function ($$v) {_vm.notes=$$v},expression:"notes"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }